// @generated by tools/docgen — do not edit.
// Source: docs/quickstart.md

import React from 'react';

export function QuickstartPage() {
  return (
    <div className="mx-auto w-full max-w-3xl flex-1 overflow-y-auto px-6 py-10">
      <h1 className="text-2xl font-semibold tracking-tight text-ink">
        Quickstart
      </h1>
      <p className="mt-4 max-w-prose text-base leading-relaxed text-primary-800">
        This walkthrough sets up a minimal RxDjango app: a Django channel holding one reactive value, and a React component bound to it. RxDjango is working towards v0.1 and is not yet published on PyPI or npm — both packages install from the git repository for now.
      </p>
    </div>
  );
}

export default QuickstartPage;
